import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import type {
  BankTransferDetails,
} from "@/components/children/bankTransferDetails/scripts";

import {
  countCharacterSepaField,
  getInvalidCharacters,
} from "@/scripts/Common/helpers";

import {
  hasSepaConditionForId,
  hasValidLengthOnSepaCondition
} from "@/scripts/Common/validators";

import {
  SEPA_CHARACTER_REPLACER_REGEX_ID,
} from "@/scripts/Constants";

import {
  MAX_E2E_REFERENCE_LENGTH,
} from "@/components/children/bankTransferDetails/scripts";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankTransferDetails',
  props: {
  bankTransferDetails: {
    required: true,
    type: Object as PropType<BankTransferDetails>
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  expanded: {
    required: false,
    type: Array as PropType<Array<number>>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'update:reference',
],
  setup(__props, { emit: emits }) {

const props = __props;






const valid = ref(false);
const internalExpand = ref(props.expanded);

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded;
})

watch(valid, () => emits('onValidChange', unref(valid)))


return { __sfc: true,props, emits, valid, internalExpand, countCharacterSepaField, getInvalidCharacters, hasSepaConditionForId, hasValidLengthOnSepaCondition, SEPA_CHARACTER_REPLACER_REGEX_ID, MAX_E2E_REFERENCE_LENGTH }
}

})